import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "../_placeholders/-assets/placeholder-people.png";

export const Route = createFileRoute("/_staff/licenses/_list/people/")({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
